<template>
  <el-dialog
      custom-class="!rounded-none flex flex-col justify-center items-center"
      width="80%"
      :visible="true"
      :center="true"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose(true)">
    <span slot="title" class="text-2xl font-semibold text-center mb-2">
      Choose an Integration
    </span>

    <div class="w-full px-4 md:px-0">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
            v-for="integration in remainingIntegrations"
            :key="integration.id"
            class="relative border-2 rounded-lg p-4 flex flex-col items-center cursor-pointer hover:shadow-lg transition-shadow"
            :class="{ 'border-body-black border-2': selectedIntegration === integration.id,
                      'hover:shadow-none cursor-not-allowed': isIntegrationPresent(integration.id) }"
            @click="selectIntegration(integration.id)">
          <span v-if="isIntegrationPresent(integration.id)"
                class="absolute top-2 left-2 px-2 text-sm leading-sm bg-onvocado-primary rounded-full">active</span>
          <img :src="integration.logo" :alt="integration.name" class="w-24 h-16 mb-4"/>
          <h3 class="text-lg font-medium mb-2">{{ integration.name }}</h3>
          <p class="text-sm text-gray-600 text-center">{{ integration.description }}</p>
        </div>
      </div>
    </div>

    <div slot="footer" class="text-center dialog-footer">
      <button
          class="w-48 btn primary"
          type="button"
          :disabled="!selectedIntegration || submitting"
          @click="confirmSelection">
        Select Integration
      </button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { INTEGRATIONS } from '@meta/integrations'

export default {
  name: 'IntegrationsModal',
  data() {
    return {
      integrations: INTEGRATIONS,
      selectedIntegration: null,
      submitting: false,
    }
  },
  computed: {
    ...mapGetters('integration', ['isIntegrationPresent']),
    remainingIntegrations() {
      return this.integrations.slice(4)
    },
  },
  methods: {
    selectIntegration(name) {
      if (!this.isIntegrationPresent(name)) {
        this.selectedIntegration = name
      }
    },
    confirmSelection() {
      if (!this.selectedIntegration) return
      this.submitting = true
      this.handleClose()
    },
    handleClose(force) {
      if (force) {
        this.selectedIntegration = null
      }
      this.$emit('close', this.selectedIntegration)
    },
  },
}
</script>